<template>

  <div id="tour-students-page" class="flex flex-1 space-x-2">
    <DashboardHeaderTab
      :title="`${labels.STUDENT}s`"
      :description="`Admit, manage, import and promote ${labels.STUDENT.toLowerCase()}s across your school.`"
      icon="pi-users"
      :tabs="visibleTabs"
      :activeTab="activeTab"
      :setActiveTab="setActiveTab"
      :toggleSidebar="toggleSidebar"
    />

  </div>

</template>

<script setup lang="ts">
import DashboardHeaderTab from '@/components/DashBoard/common/DashboardHeaderTab.vue';
import { useTabs } from '@/composables/useTabs';

import AdmitStudent from '@/components/DashBoard/Student/AdmitStudent/AdmitStudent.vue';
import Overview from '@/components/DashBoard/Student/Overview/OverView.vue';
import Import from '@/components/DashBoard/Student/Import.vue';
import Promote from '@/components/DashBoard/Student/Promote/Promote.vue';
import ArchivedStudents from '@/components/DashBoard/Student/ArchivedStudents.vue';
import { useSchoolLabels } from '@/composables/useSchoolLabels';
import { useStaffDashboard } from '@/composables/useStaffDashboard';

const { labels } = useSchoolLabels();
const { canCreateStudents } = useStaffDashboard();
const toggleSidebar = inject<() => void>('toggleSidebar', () => { });

const allTabs = computed(() => [
  { name: `Admit New ${labels.value.STUDENT}`, component: AdmitStudent, query: '', icon: 'pi-user-plus', adminOnly: true },
  { name: `${labels.value.STUDENT} Overview`, component: markRaw(Overview), query: 'overview', icon: 'pi-list', adminOnly: false },
  { name: `Import ${labels.value.STUDENT}s`, component: markRaw(Import), query: 'import', icon: 'pi-cloud-upload', adminOnly: true },
  { name: `Promote ${labels.value.STUDENT}s`, component: markRaw(Promote), query: 'promote', icon: 'pi-arrow-right-arrow-left', adminOnly: true },
  { name: 'Archived', component: markRaw(ArchivedStudents), query: 'archived', icon: 'pi-box', adminOnly: true },
]);

const visibleTabs = computed(() => {
  if (canCreateStudents.value) {
    return allTabs.value;
  }
  return allTabs.value.filter(t => !t.adminOnly);
});

const { activeTab, setActiveTab } = useTabs(visibleTabs);
</script>

<style lang="scss" scoped></style>
